import { ReduxState } from 'app/redux/types';

import { selectClientInfo, selectClientInfoData } from './state';

// ---

export const selectClientInfoLoading = (state: ReduxState): boolean => (
  selectClientInfo(state).clientInfoLoading
);

export const selectClientInfoRequested = (state: ReduxState): boolean => (
  selectClientInfo(state).clientInfoRequested
);

export const selectClientInfoSettingsLoading = (state: ReduxState): boolean => (
  selectClientInfo(state).clientInfoSettingsLoading
);
export const selectClientInfoSettingsRequested = (state: ReduxState): boolean => (
  selectClientInfo(state).clientInfoSettingsRequested
);


export const clientId = (state: ReduxState) => (
  selectClientInfoData(state)?.clientId
);

export const accountUsername = (state: ReduxState) => (
  selectClientInfoData(state)?.username
);

export const accountFullName = (state: ReduxState) => (
  selectClientInfoData(state)?.fullName
);

export const accountFirstName = (state: ReduxState) => (
  selectClientInfoData(state)?.firstName
);

export const accountMiddleName = (state: ReduxState) => (
  selectClientInfoData(state)?.middleName
);

export const accountLastName = (state: ReduxState) => (
  selectClientInfoData(state)?.lastName
);

export const hasAccountRequiredName = (state: ReduxState) => (
  Boolean(accountFirstName(state) && accountLastName(state))
);

export const hasTransactionsSelector = (state: ReduxState) => (
  selectClientInfoData(state)?.hasTransactions ?? false
);

export const selectAccountBalance = (state: ReduxState) => {
  const balance = selectClientInfoData(state)?.balance;
  return typeof balance === 'number' ? balance : null;
};

export const isAccountBalance = (state: ReduxState) => {
  const balance = selectClientInfoData(state)?.balance;
  return balance ? balance > 0 : false;
};

export const selectAccountWithdrawalBalance = (state: ReduxState) => {
  const withdrawalBalance = selectClientInfoData(state)?.withdrawalBalance;
  return typeof withdrawalBalance === 'number' ? withdrawalBalance : null;
};

export const selectClientProfilePhone = (state: ReduxState) => (
  selectClientInfoData(state)?.phoneNumber
);

export const accountCurrency = (state: ReduxState) => (
  selectClientInfoData(state)?.currency
);

export const selectCashbackRate = (state: ReduxState) => (
  selectClientInfoData(state)?.cashbackRate
);

export const selectCashback = (state: ReduxState) => (
  selectClientInfoData(state)?.cashback
);
